import React, { Component, PropTypes } from 'react'
import styled from 'styled-components'
import { translate } from 'react-i18next'
import R from 'ramda'
import { Half } from 'grid-styled'
import {
  findUsersByName,
  addUsersToProperties
} from '../../sources/AdminSource'
import {
  sortArray,
  addOrRemoveObjectFromList,
  isElementSelected
} from '../../Utils'
import { tableKeysDefault, searchQueryDefault } from '../../Utils/Defaults'
import { findProperties } from '../../sources/SearchSource'
import { Metrics, Fonts } from '../../Themes'
import AdminNavbar from '../../components/AdminNavbar'
import SearchBar from '../../components/SearchBar'
import Table from '../../components/Table'
import Modal from '../../components/Modal'
import Checkbox from '../../components/Checkbox'
import Input from '../../components/Input'
import Button from '../../components/Button'

const Container = styled.section`
  height: calc(100vh - (${Metrics.components.navbarDefault} + ${Metrics
  .components.searchbar}))
  margin-top: calc(${Metrics.components.adminNavbar}px - 1px);

  .searchbar-container {
    top: calc(${Metrics.components.adminNavbar}px - 1px);
  }
`

const TableContainer = styled.div`
  margin-top: calc(${Metrics.components.searchbar} - 1px);
  height: calc(
    100vh - (${Metrics.components.adminNavbar}px +
          ${Metrics.components.searchbar})
  );
  .table-checkbox {
    svg {
      padding-top: 13px;
    }
  }

  #table-body {
    padding: 0 ${Metrics.margins.larger} !important;
  }
`

const InputContainer = styled.div`
  margin-top: ${Metrics.margins.small};
  margin-bottom: ${Metrics.margins.larger};
`

const ListContainer = styled.div`
  border: ${Metrics.borders.default};
  border-radius: ${Metrics.borders.defaultRadius};
  height: 150px;
  overflow: scroll;
`

const User = styled.div`
  text-align: left;
  padding: ${Metrics.margins.small};
  ${Fonts.style.Text};
  cursor: pointer;
`

const ModalHeader = styled.div`text-align: left;`

const UsersList = styled.div``

const Label = styled.div`
  ${Fonts.style.Text};
  text-align: left;
`

const ButtonContainer = styled.div`
  margin-bottom: ${Metrics.margins.base};
  height: ${Metrics.margins.larger};
  button {
    float: right;
  }
`

const CustomHalf = styled(Half)`
  padding-left: ${props => (props.noPadLeft ? 0 : Metrics.margins.small)};
  padding-right: ${props => (props.noPadRight ? 0 : Metrics.margins.small)};
  margin-bottom: ${props =>
    props.mgSmall ? Metrics.margins.tiny : Metrics.margins.base};
`

const NoUsers = styled.div`margin-top: ${Metrics.margins.base};`

class AdminProperties extends Component {
  constructor (props) {
    super(props)
    this.state = {
      userSearch: '',
      open: false,
      counter: 0,
      canLoadMore: true,
      isFetching: false,
      allPropertiesSelected: false,
      properties: [],
      selectedProperties: [],
      selectedUsers: [],
      users: [],
      settings: R.clone(searchQueryDefault),
      tableHeaderKeys: R.prepend(
        {
          title: props.t('Select All'),
          key: 'selected',
          width: 80,
          accessor: d => {
            return (
              <Checkbox
                className='table-checkbox'
                id={`checkbox-${d.id}`}
                checked={isElementSelected(d, this.state.selectedProperties)}
                onClick={event => {
                  event.stopPropagation()
                  this.selectElement(d, 'selectedProperties')
                }}
              />
            )
          },
          sort: null,
          onClick: this.selectAllProperties
        },
        R.clone(tableKeysDefault)
      )
    }
    this.updateSettings = this.updateSettings.bind(this)
    this.propertyDetails = this.propertyDetails.bind(this)
    this.retrieveProperties = this.retrieveProperties.bind(this)
    this.filterProperties = this.filterProperties.bind(this)
    this.handleSort = this.handleSort.bind(this)
    this.toggleModal = this.toggleModal.bind(this)
    this.selectAllProperties = this.selectAllProperties.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
    this.usersToAdd = this.usersToAdd.bind(this)
    this.selectElement = this.selectElement.bind(this)
    this.updatePropertiesUsers = this.updatePropertiesUsers.bind(this)
  }

  componentWillMount () {
    this.retrieveProperties()
  }

  retrieveProperties () {
    const { settings, counter, properties } = this.state
    this.setState({ isFetching: true }, () => {
      findProperties({ settings, skip: counter, limit: 50 })
        .then(response => {
          const { results = [], noResults } = response.data
          let propertiesSet = R.concat(properties, results)
          propertiesSet = propertiesSet.map(el => {
            return Object.assign({}, el, { selected: false })
          })
          this.setState({
            properties: propertiesSet,
            counter: propertiesSet.length,
            canLoadMore: propertiesSet.length < noResults,
            isFetching: false
          })
        })
        .catch(error => {
          console.log(error)
          this.setState({ isFetching: false })
        })
    })
  }

  filterProperties () {
    const { settings } = this.state
    this.setState({ isFetching: true }, () => {
      findProperties({ settings, limit: 50 })
        .then(response => {
          const { results = [], noResults } = response.data
          const propertiesSet = results.map(el => {
            return Object.assign({}, el, { selected: false })
          })
          this.setState({
            properties: propertiesSet,
            counter: propertiesSet.length,
            canLoadMore: propertiesSet.length < noResults,
            isFetching: false
          })
        })
        .catch(error => {
          console.log(error)
          this.setState({ isFetching: false })
        })
    })
  }

  updateSettings (settings) {
    this.setState({ settings }, () => {
      this.filterProperties()
    })
  }

  propertyDetails (id) {
    this.props.router.push('/admin/properties/' + id)
  }

  handleSort (el) {
    const keys = R.clone(this.state.tableHeaderKeys)
    const keyIndex = R.findIndex(R.propEq('title', el.title), keys)
    const result = sortArray(el, this.state.properties)
    keys.forEach(el => {
      el.sort = null
    })
    keys[keyIndex] = result.sortKey
    this.setState({ properties: result.list, tableHeaderKeys: keys })
  }

  toggleModal () {
    this.setState({ open: !this.state.open, userSearch: '' })
  }

  selectAllProperties () {
    const { properties, allPropertiesSelected } = this.state
    this.setState({
      allPropertiesSelected: !allPropertiesSelected,
      selectedProperties: allPropertiesSelected ? [] : properties
    })
  }

  selectElement (el, arrayName) {
    const newState = this.state
    newState[arrayName] = addOrRemoveObjectFromList(newState[arrayName], el)
    this.setState(newState)
  }

  handleSearch (event) {
    const name = event.target.value
    this.setState({ userSearch: name }, () => {
      findUsersByName(name)
        .then(response => {
          this.setState({ users: response.data })
        })
        .catch(error => console.log(error))
    })
  }

  updatePropertiesUsers () {
    const { selectedUsers, selectedProperties } = this.state
    const properties = selectedProperties.map(property => property.id)
    const users = selectedUsers.map(user => user.id)
    addUsersToProperties(properties, users)
      .then(response => this.toggleModal())
      .catch(error => console.log(error))
  }

  usersToAdd () {
    const { users, userSearch, selectedUsers } = this.state
    const { t } = this.props
    let usersList = ''

    usersList =
      users.length > 0 ? (
        users.map((el, index) => {
          return (
            <User
              onClick={() => this.selectElement(el, 'selectedUsers')}
              key={`user-${index}`}>
              {`${el.firstName} ${el.lastName}`}
            </User>
          )
        })
      ) : (
        <NoUsers>{t('There are no users')}</NoUsers>
      )

    return (
      <div>
        <InputContainer>
          <Input
            value={userSearch}
            handleChange={this.handleSearch}
            placeholder={t('Search for name')}
          />
        </InputContainer>
        <CustomHalf noPadLeft mgSmall>
          <Label>{t('Users')}</Label>
        </CustomHalf>
        <CustomHalf noPadRight mgSmall>
          <Label>{t('Selected Users')}</Label>
        </CustomHalf>
        <CustomHalf noPadLeft>
          <UsersList>
            <ListContainer>{usersList}</ListContainer>
          </UsersList>
        </CustomHalf>
        <CustomHalf noPadRight>
          <ListContainer>
            {selectedUsers.length > 0 &&
              selectedUsers.map((el, index) => {
                return (
                  <User
                    onClick={() => this.selectElement(el, 'selectedUsers')}
                    key={`selecteduser-${index}`}>
                    {`${el.firstName} ${el.lastName}`}
                  </User>
                )
              })}
            {selectedUsers.length === 0 && (
              <NoUsers>{t('There are no users selected')}</NoUsers>
            )}
          </ListContainer>
        </CustomHalf>
      </div>
    )
  }

  render () {
    const { children, t, router, admin, dropdownLinks } = this.props
    const {
      tableHeaderKeys,
      properties,
      settings,
      canLoadMore,
      isFetching,
      open,
      selectedProperties
    } = R.clone(this.state)
    const width = window.screen.availWidth - 200
    const height =
      document.getElementById('propertyList') &&
      document.getElementById('propertyList').offsetHeight

    return (
      <section>
        <Modal
          visible={open}
          closeAction={this.toggleModal}
          style={{
            padding: `${Metrics.margins.small} ${Metrics.margins.large}`
          }}
          header={
            <ModalHeader>
              {t(`Add users to ${selectedProperties.length} properties`)}
            </ModalHeader>
          }>
          {this.usersToAdd()}
          <ButtonContainer>
            <Button
              secondary
              onClick={this.updatePropertiesUsers}
              label='Save'
            />
          </ButtonContainer>
        </Modal>
        <AdminNavbar
          dropdownLinks={dropdownLinks}
          fixedSearchBar
          admin={admin}
          rightSideActions={[
            {
              label: t('Add Users'),
              primary: true,
              onClick: this.toggleModal,
              disabled: selectedProperties.length === 0
            },
            {
              label: t('Create Property'),
              secondary: true,
              onClick: () => {
                router.push('/admin/properties/new')
              }
            }
          ]}
        />
        <Container>
          <SearchBar
            isAdmin
            settings={settings}
            updateSettings={this.updateSettings}
            isAdminPage
          />
          <TableContainer id='propertyList'>
            <Table
              data={properties}
              keys={tableHeaderKeys}
              height={height}
              width={width}
              isFetching={isFetching}
              loadMore={this.retrieveProperties}
              canLoadMore={canLoadMore}
              handleSort={this.handleSort}
              rowClick={this.propertyDetails}
              selectedElements={selectedProperties}
            />
          </TableContainer>
          {children}
        </Container>
      </section>
    )
  }
}

AdminProperties.propTypes = {
  children: PropTypes.node,
  admin: PropTypes.object,
  router: PropTypes.object,
  location: PropTypes.object,
  t: PropTypes.func,
  dropdownLinks: PropTypes.array
}

export default translate([ 'common', 'admin', 'forms' ], { wait: true })(
  AdminProperties
)



// WEBPACK FOOTER //
// ./src/pages/AdminProperties/index.js